import { useAppSelector } from 'reduxTyped'
import AccountModel from 'common/core/models/Account'
import {
  getCurrentAccount,
  isAccountBlocked,
  isTrialAvailable,
} from 'common/core/selectors/appSelectors'
import { getIsSidebarHidden } from 'common/core/selectors/uiSelectors'
import { getIsNeedToShowPayNow } from 'common/settings/selectors/settingsSelectors'

export const useBottomContentParams = () => {
  const account = useAppSelector(getCurrentAccount)
  const isPRO = AccountModel.isProOrTrial(account)
  const isBlocked = useAppSelector(isAccountBlocked)
  const isContactsLimitBanner = AccountModel.isFree(account) || isBlocked
  const isRetryPayment = useAppSelector(getIsNeedToShowPayNow)
  const hasTrial = useAppSelector(isTrialAvailable)
  const isSidebarHidden = useAppSelector(getIsSidebarHidden)
  return {
    pageId: account?.page_id,
    isPRO,
    isContactsLimitBanner,
    isRetryPayment,
    hasTrial,
    isSidebarHidden,
  }
}
